import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './index.scss';
import Delay from '../../base/delay';
import { LAYERS } from '../../layers/types';
import * as MainActions from '../../main/actions';
import { getWidgetDisplay } from '../../layers/widget/helpers';
import MinimizeIcon from '../../../common/icons/minus.svg';
import CloseIcon from '../../../common/icons/close-slim.svg';

class MaximizedFrame extends React.Component {
    constructor() {
        super();
        this.state = {
            isVisible: false
        };
    }

    refCallback(element) {
        if (element) {
            MainActions.updateMainLayer({
                layer: LAYERS.WIDGET,
                iFrameMode: getWidgetDisplay(),
                source: 'maximizedFrame'
            });
        }
    }

    onOpen() {
        this.setState({ isVisible: true });
    }

    onClose() {
        this.setState({ isVisible: false });
        this.props.events.close ? this.props.events.close('maximizedCountdownTimeout') : null;
    }

    render() {
        const { title, style, events, delays, children, mainClassName, parentHeight } = this.props;
        const classes = 'maximized-frame ' + (style ? style : '');
        const inlineHeight = parentHeight < 609 ? { height: parentHeight - 20 } : null;

        return (
            <Delay
                showAfter={delays.showAfter}
                hideAfter={delays.hideAfter}
                onOpen={() => this.onOpen()}
                onClose={() => this.onClose()}
            >
                {this.state.isVisible && (
                    <div className={classes} ref={this.refCallback} style={inlineHeight}>
                        <header>
                            <div className="title">{title}</div>
                            <div className="buttons">
                                <div className="minimize">
                                    {events.minimize && (
                                        <a
                                            href="#"
                                            onClick={events.minimize}
                                            className="minimize--icon"
                                        >
                                            <MinimizeIcon />
                                        </a>
                                    )}
                                </div>
                                <div className="close">
                                    {events.close && (
                                        <a href="#" onClick={events.close} className="close--icon">
                                            <CloseIcon />
                                        </a>
                                    )}
                                </div>
                            </div>
                        </header>
                        <div className={'main ' + (mainClassName ? mainClassName : '')}>
                            <div className="content">{children}</div>
                        </div>
                    </div>
                )}
            </Delay>
        );
    }
}

MaximizedFrame.defaultProps = {
    mainClassName: 'scroll',
    delays: {
        showAfter: 0,
        hideAfter: 0
    }
};

MaximizedFrame.propTypes = {
    title: PropTypes.string,
    style: PropTypes.string,
    events: PropTypes.object.isRequired,
    delays: PropTypes.object,
    children: PropTypes.node.isRequired
};

const mapStateToProps = state => {
    return {
        parentHeight: state.main.device === 'DESKTOP' ? state.main.parentHeight : 1000
    };
};

export default connect(mapStateToProps)(MaximizedFrame);
